var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageDashboard"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-img',{attrs:{"contain":"","lazy-src":"/images/logo/jaqueSAI-logo.jpg","src":"/images/logo/jaqueSAI-logo.jpg","max-height":"1000"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }